import { css } from 'linaria';

export const ShowMoreCategoriesBtnStyles = css`
	width: 100%;
	margin-top: 40px;
`;
